
        import * as module0 from './config/api.js';import * as module1 from './config/bifrost.js';import * as module2 from './config/page.js'

        const modules = [module0,module1,module2];

        export default modules;
        export const filenames = ['./config/api.js','./config/bifrost.js','./config/page.js']
      